/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unit: NonNullable<unknown> }} Workout_Quick_Load_LabelInputs */

const en_us2_workout_quick_load_label = /** @type {(inputs: Workout_Quick_Load_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Load (${i?.unit})`)
};

const pt_br2_workout_quick_load_label = /** @type {(inputs: Workout_Quick_Load_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga (${i?.unit})`)
};

const es_419_workout_quick_load_label = /** @type {(inputs: Workout_Quick_Load_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga (${i?.unit})`)
};

const pt_pt2_workout_quick_load_label = /** @type {(inputs: Workout_Quick_Load_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga (${i?.unit})`)
};

const fr_fr2_workout_quick_load_label = /** @type {(inputs: Workout_Quick_Load_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Charge (${i?.unit})`)
};

const de_de2_workout_quick_load_label = /** @type {(inputs: Workout_Quick_Load_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gewicht (${i?.unit})`)
};

const it_it2_workout_quick_load_label = /** @type {(inputs: Workout_Quick_Load_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carico (${i?.unit})`)
};

/**
* | output |
* | --- |
* | "Load ({unit})" |
*
* @param {Workout_Quick_Load_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_load_label = /** @type {((inputs: Workout_Quick_Load_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Load_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_load_label(inputs)
	if (locale === "es-419") return es_419_workout_quick_load_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_load_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_load_label(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_load_label(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_load_label(inputs)
	return en_us2_workout_quick_load_label(inputs)
});
export { workout_quick_load_label as "workout-quick.load_label" }